"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
const enums_1 = require("../../shared-types/enums");
const invalidEmailMessage = 'Invalid email address';
const phoneNumberMessage = 'Phone number must be in international format (e.g. +18885551234)';
const phoneNumberRegex = /^\+\d{11,}$/;
exports.requestSchema = zod_1.z.object({
    id: zod_1.z.number(),
    firstName: zod_1.z.string().min(1),
    lastName: zod_1.z.string().min(1),
    email: zod_1.z.string().email({ message: invalidEmailMessage }),
    accountType: enums_1.accountTypeEnum,
    language: enums_1.languageEnum,
    phoneNumber: zod_1.z.string().regex(phoneNumberRegex, { message: phoneNumberMessage }).optional().nullable(),
    smsNumber: zod_1.z.string().regex(phoneNumberRegex, { message: phoneNumberMessage }).optional().nullable(),
    country: zod_1.z.string(),
    locationLevel1: zod_1.z.string().optional().nullable(),
    units: enums_1.customerUnitEnum,
});
exports.path = '/admin-update-user-profile';
//# sourceMappingURL=index.js.map